module.exports = __webpack_public_path__ + "static/media/Logo.67eb53d3.png";